import { CobaltTagColor } from '@cae/cobalt-react/components/tag';
import { UserStatus } from '@features/users/api/types/user.types';

export interface TableColumn {
  id: string;
  label: string;
  sortable: boolean;
  width: string;
}

export const TABLE_COLUMNS: TableColumn[] = [
  { id: 'name', label: 'Name', sortable: true, width: '10rem' },
  { id: 'email', label: 'Email', sortable: true, width: '16rem' },
  {
    id: 'role',
    label: 'Role',
    sortable: false,
    width: '16rem',
  },
  { id: 'lastLogin', label: 'Last Login', sortable: true, width: '10rem' },
  {
    id: 'lastModified',
    label: 'Last Modified',
    sortable: true,
    width: '10rem',
  },
  { id: 'status', label: 'Status', sortable: true, width: '10rem' },
];

export function getUsersStatusTagColor(status: UserStatus): CobaltTagColor {
  if (status === 'Active') {
    return 'blue';
  }
  return 'neutral';
}
